import { Component, Input } from '@angular/core';

@Component({
  selector: 'kp-dashes',
  templateUrl: './dashes.component.html',
  styleUrls: ['./dashes.component.scss'],
})
export class DashesComponent {
  @Input() isTrendingDown = false;
}
